import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'orderColumns',
    standalone: true
})
export class OrderColumnsPipe implements PipeTransform {
    transform(items: any[], columnsPerPage: number = 3, rowsPerPage: number = 4): any[] {
        if (!items || !Array.isArray(items)) {
            return [];
        }

        const itemsPerPage = columnsPerPage * rowsPerPage;
        const columns: any[] = [];
        
        items.forEach((item, index) => {
            const pageIndex = Math.floor(index / itemsPerPage);
            const columnIndex = (pageIndex * columnsPerPage) + (index % columnsPerPage);
            
            if (!columns[columnIndex]) {
                columns[columnIndex] = [];
            }
            columns[columnIndex].push({ data: item, index: index });
        });
        return columns;
    }
}